import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';
export const glacierPeaksMetadata = {
  id: 'glacier-peaks',
  name: 'Glacier Peaks',
  description:
    'The tour’s highest alpine test, climbing and falling among conifers, exposed rock, ravines and immense cold valley views.',
  environmentPreset: 'high-alpine',
  metadata: {
    location: 'Canadian Rockies',
    regionType: 'high alpine valleys',
    difficulty: 83,
    typicalWind: [4, 19] as const,
    greenSpeed: [10, 11] as const,
    firmness: 'medium-firm' as const,
    primaryChallenge: 'The highest and most vertical tour venue',
    signatureHoles: [4, 8, 13, 18],
    tournamentEventId: 'event-13',
    previewTheme: 'high-alpine',
    environmentPalette: {
      fairway: '#63845b',
      rough: '#35503d',
      bunker: '#cabf9d',
      water: '#5a91a4',
      haze: '#cadbe4',
      sky: '#92bad8',
      rock: '#84909a',
      wasteArea: '#c2b38d',
    },
    vegetationStyle: 'alpine conifer, low-to-medium density',
    terrainStyle: terrainPreset('high-alpine', 48, 150, 1.1).id,
    sunlightDirection: 'southwest high-altitude sun',
    distantScenery: 'snow peaks, rock faces and deep valleys',
    waterStyle: 'cold steel-blue alpine water',
    eventPresentation: {
      accentColor: '#92bad8',
      mark: 'GLACIER',
      subtitle: 'Golf above the clouds',
      loadingCopy: 'Judge every climb and fall',
      identityLine: 'The highest and most vertical tour venue',
      tierLabel: 'STANDARD',
    },
    wasteArea: { carryMultiplier: 0.91, consistencyMultiplier: 0.88, rollMultiplier: 0.72 },
  },
};
const pars = [4, 5, 4, 3, 4, 4, 3, 4, 5, 4, 4, 3, 4, 5, 3, 4, 5, 4];
const yards = [
  425, 580, 410, 205, 440, 395, 175, 335, 570, 430, 450, 160, 350, 590, 190, 420, 555, 475,
];
const names = [
  'Valley Gate',
  'Thin Air',
  'Granite Shelf',
  'Freefall',
  'Timberline',
  'Sidehill',
  'Ice Blue',
  'Ravine Dare',
  'Long Climb',
  'North Face',
  'Conifer Bend',
  'Snowfield',
  'Chasm Carry',
  'Three Steps',
  'Echo',
  'Cold Ridge',
  'Last Ascent',
  'Clubhouse Climb',
];
const options: Partial<HolePlan>[] = [];
options[1] = { elevation: { tee: 2, landing: 18, green: 35 }, rocks: 4 };
options[3] = { elevation: { tee: 42, landing: 18, green: 3 }, greenRadius: 22 };
options[8] = { elevation: { tee: 0, landing: 22, green: 40 }, rocks: 5 };
options[12] = { splitFairway: true, elevation: { tee: 20, landing: 8, green: 12 }, rocks: 5 };
options[17] = { elevation: { tee: 0, landing: 18, green: 38 }, rocks: 4 };
export const createGlacierPeaksDocument = () =>
  authorCourse({
    ...glacierPeaksMetadata,
    plans: plans(names, pars, yards, options).map((plan) => ({
      ...plan,
      trees: plan.trees ?? 5,
      rocks: plan.rocks ?? 3,
    })),
  });
